import { render, staticRenderFns } from "./AdminProcessNav.vue?vue&type=template&id=54ca1f28&scoped=true&"
import script from "./AdminProcessNav.vue?vue&type=script&lang=js&"
export * from "./AdminProcessNav.vue?vue&type=script&lang=js&"
import style0 from "./AdminProcessNav.vue?vue&type=style&index=0&id=54ca1f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca1f28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
